// Product Variations Slider
const variantScroller = function () {
  const sortElements = function () {
    const parent = document.querySelector("#variant-picker_parent");
    if (!parent) return;
    let childrenArray = Array.from(parent.children);

    childrenArray.sort(function (a, b) {
      let availA = a.getAttribute("data-available") === "true";
      let availB = b.getAttribute("data-available") === "true";

      if (availA && !availB) return -1;
      if (!availA && availB) return 1;

      let rankA = parseInt(a.getAttribute("data-ranking"));
      let rankB = parseInt(b.getAttribute("data-ranking"));
      return rankA - rankB;
    });

    childrenArray.forEach((child) => parent.appendChild(child));
  };

  sortElements();

  const options = document.querySelectorAll(
    ".custom-variant-picker .thumbnail-swatch"
  );
  const sliderWrapper = document.querySelector(
    ".custom-variant-picker .variant-picker__option-values-wrapper"
  );
  if (!sliderWrapper) return;

  const optionSize = options[0].offsetWidth;
  const resizeVariantOptions = function () {
    const resize = function (pixel) {
      options.forEach((el) => (el.style.width = `${optionSize + pixel}px`));
      options.forEach((el) => (el.style.height = `${optionSize + pixel}px`));
    };

    resize(0);
    const sliderSize = sliderWrapper.offsetWidth;
    const slideOffset = String(sliderSize / (optionSize + 8))
      .split(".")[1]
      .slice(0, 2);

    if (slideOffset < 30) {
      resize(-2);
    } else if (slideOffset > 70) {
      resize(2);
    }
  };

  resizeVariantOptions();
  window.addEventListener("resize", resizeVariantOptions);

  const carousel = document.querySelector(
    ".custom-variant-picker .variant-picker__option-values"
  );
  const scrollSteps = Number(carousel.dataset.steps);
  const left = document.querySelector(".variant-picker__nav-btn.left");
  const right = document.querySelector(".variant-picker__nav-btn.right");
  const item = document.querySelector(
    ".custom-variant-picker .thumbnail-swatch"
  );

  let slide = 0;
  const maxSlides = Math.ceil(
    document.querySelectorAll(".custom-variant-picker .thumbnail-swatch")
      .length / scrollSteps
  );

  right.addEventListener("click", function (e) {
    carousel.scrollLeft += item.clientWidth * scrollSteps;
    slide++;
    checkPosition(slide);
  });
  left.addEventListener("click", function () {
    carousel.scrollLeft -= item.clientWidth * scrollSteps;
    slide--;
    checkPosition(slide);
  });

  const checkPosition = function (slide) {
    slide === 0 ? (left.disabled = true) : (left.disabled = false);
    slide === maxSlides ? (right.disabled = true) : (right.disabled = false);
  };

  checkPosition(slide);
};
document.addEventListener("DOMContentLoaded", variantScroller);

// Countdown Timer

const countdownTimer = function () {
  if (!document.querySelector(".shopify-section--countdown-condensed")) return;

  document.querySelectorAll(".countdown-condensed__timer").forEach(function (timer) {
    console.log(timer);

    // Sticky
    const calcSticky = function () {
      const headerHeight = document.querySelector(
        ".shopify-section--header"
      ).offsetHeight;
      timer.closest(
        ".shopify-section--countdown-condensed"
      ).style.top = `${headerHeight}px`;
    };

    calcSticky();
    window.addEventListener("resize", calcSticky);

    // Timer Functionality
    const expiresAt = timer.getAttribute("expires-at");
    const startsAt = timer.getAttribute("starts-at");
    const intervalMinutes = parseInt(timer.getAttribute("expiration-intervall"), 10);

    if (!expiresAt || !startsAt) return;

    const daysEl = timer.querySelector('[type="days"]');
    const hoursEl = timer.querySelector('[type="hours"]');
    const minutesEl = timer.querySelector('[type="minutes"]');
    const secondsEl = timer.querySelector('[type="seconds"]');

    const expireDate = new Date(expiresAt).getTime();
    const startDate = new Date(startsAt).getTime();

    const show = timer.getAttribute("data-show");
    let showTimer = false;
    if (show === "false") showTimer = true;

    if (!isNaN(intervalMinutes)) {
      // Neuer Modus: Intervallbasiert
      setInterval(function () {
        const now = new Date().getTime();

        // Check if current time is within the valid range
        if (now < startDate || now > expireDate) {
          console.log(new Date(now), new Date(startDate), new Date(expireDate))
          console.log("abgelaufen")
          timer.closest(".countdown-condensed").style.maxHeight = "0px";
          timer.closest(".countdown-condensed").style.padding = "0px";
          return;
        }

        // Berechnung der verbleibenden Zeit basierend auf dem Intervall
        const intervalMilliseconds = intervalMinutes * 60 * 1000;
        const elapsedTime = (now - startDate) % intervalMilliseconds;
        const remainingTime = intervalMilliseconds - elapsedTime;

        const days = Math.floor(remainingTime / (1000 * 60 * 60 * 24));
        const hours = Math.floor(
          (remainingTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        );
        const minutes = Math.floor((remainingTime % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((remainingTime % (1000 * 60)) / 1000);

        // Aktualisiere Timer-Anzeige
        daysEl.textContent = days;
        hoursEl.textContent = hours;
        minutesEl.textContent = minutes;
        secondsEl.textContent = seconds;

        if (!showTimer) {
          timer.closest(".countdown-condensed").style.maxHeight = "300px";
          timer.closest(".countdown-condensed").style.padding = "1rem 1.25rem";
          showTimer = true;
        }
      }, 1000);
    } else {
      // Alter Modus: Standard-Countdown
      setInterval(function () {
        const now = new Date().getTime();

        // Check if current time is within the valid range
        if (now < startDate || now > expireDate) {
          timer.closest(".countdown-condensed").style.maxHeight = "0px";
          timer.closest(".countdown-condensed").style.padding = "0px";
          return;
        }

        // Calculate time remaining
        const distance = expireDate - now;

        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor(
          (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        );
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        // Hide timer if expired
        const hideTimer = function () {
          timer.closest(".countdown-condensed").style.maxHeight = "0px";
          timer.closest(".countdown-condensed").style.padding = "0px";
          showTimer = true;
        };

        if (!days && !hours && !minutes && !seconds) hideTimer();
        if (days < 0 && hours < 0 && minutes < 0 && seconds < 0) {
          hideTimer();
          showTimer = true;
        }

        // Aktualisiere Timer-Anzeige
        daysEl.textContent = days;
        hoursEl.textContent = hours;
        minutesEl.textContent = minutes;
        secondsEl.textContent = seconds;

        if (!showTimer) {
          timer.closest(".countdown-condensed").style.maxHeight = "300px";
          timer.closest(".countdown-condensed").style.padding = "1rem 1.25rem";
          showTimer = true;
        }
      }, 1000);
    }
  });
};

document.addEventListener("DOMContentLoaded", countdownTimer);

const autoAddToCart = function () {
  let dataEl = document.getElementById("auto-add-to-cart");
  if (!dataEl) return;

  const method = dataEl.getAttribute("data-method");
  const giftIDs = JSON.parse(dataEl.getAttribute("data-gift-ids"));
  const sku = dataEl.getAttribute("data-sku");
  const skus = JSON.parse(dataEl.getAttribute("data-skus"));
  const threshold = Number(dataEl.getAttribute("data-threshold")) * 100;

  let item_count = undefined;

  document.addEventListener("submit", function (e) {
    if (
      e.target.closest('form[action="/cart/add"]') ||
      e.target.closest(".shopify-product-form")
    ) {
      setTimeout(handleCartUpdate, 1000);
    }
  });

  document
    .querySelector(".cart-drawer")
    .addEventListener("input", function (e) {
      if (e.target.matches("input")) {
        setTimeout(handleCartUpdate, 1000);
      }
    });

  function addItemToCart(variantId, quantity) {
    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: variantId,
        quantity: quantity,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("Item added:", data);
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:refresh", {
            bubbles: true,
          })
        );
        ++item_count;
        document.querySelector(".count-bubble").textContent = `${item_count}`;
      })
      .catch((error) => {
        console.error("Error adding item:", error);
      });
  }

  function handleCartUpdate() {
    fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        console.log(cart);
        let found = false;
        if (method === "produkt") {
          skus.forEach((sku) => {
            cart.items.forEach((item) => {
              if (item.sku === sku) {
                found = true;
              }
            });
          });
        }
        // found = cart.items.some((item) => item.sku === sku);
        if (method === "bestellsumme" && cart.total_price >= threshold)
          found = true;

        if (method === "bestellsumme_produkt") {
          let sum = 0;
          skus.forEach((sku) => {
            cart.items.forEach((item) => {
              if (item.sku === sku) {
                sum += item.price * item.quantity;
              }
            });
          });
          if (sum > threshold) found = true;
        }

        item_count = cart.item_count;

        let giftAdded = false;
        cart.items.forEach((item) => {
          giftIDs.forEach((id) => {
            if (item.id == id) giftAdded = true;
          });
        });

        if (found && giftAdded === false) {
          console.log("Add to cart");
          giftIDs.forEach((id) => addItemToCart(id, 1));
        }
      })
      .catch((error) => {
        console.error("Error fetching cart:", error);
      });
  }
};

document.addEventListener("DOMContentLoaded", function () {
  setTimeout(autoAddToCart, 50);
});

/* ========================================
   VIMEO INTEGRATION - Product Gallery Videos
   ======================================== */
document.addEventListener('DOMContentLoaded', function() {
  // Nur Vimeo-Videos INNERHALB der product-gallery
  const productGallery = document.querySelector('product-gallery');
  if (productGallery) {
    const vimeoVideos = productGallery.querySelectorAll('video-media[host="vimeo"]');
    
    vimeoVideos.forEach(videoMedia => {
      console.log('🎬 Intelligente Vimeo Lazy Loading + Preloading');
      
      let isPreloaded = false;
      let thumbnailOverlay = null;
      let playButtonOverlay = null;
      let isPlaying = false;
      
      // 1. SOFORT Thumbnail-Overlay erstellen (für sofortige Anzeige)
      createThumbnailOverlay();
      
      // 2. Intersection Observer für Lazy Loading
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !isPreloaded) {
            console.log('👀 Video ist sichtbar - starte Lazy Preloading');
            observer.unobserve(videoMedia);
            startLazyPreloading();
          }
        });
      }, {
        rootMargin: '100px' // 100px bevor Video sichtbar wird
      });
      
      observer.observe(videoMedia);
      
      function startLazyPreloading() {
        console.log('🔄 Starte Lazy Preloading für Video...');
        
        // Video starten für Preloading
        videoMedia.play();
        
        // Nach 2 Sekunden pausieren (Overlay bereits vorhanden)
        setTimeout(() => {
          videoMedia.pause();
          isPreloaded = true;
          console.log('✅ Video lazy preloaded - bereit für instant Start');
        }, 2000);
      }
      
      function createThumbnailOverlay() {
        // Nur erstellen falls noch nicht vorhanden
        if (thumbnailOverlay) {
          console.log('ℹ️ Thumbnail-Overlay bereits vorhanden');
          return;
        }
        
        console.log('🖼️ Erstelle Thumbnail-Overlay...');
        
        const thumbnail = videoMedia.querySelector('img');
        if (!thumbnail) return;
        
        // Thumbnail-Overlay erstellen
        thumbnailOverlay = document.createElement('div');
        thumbnailOverlay.style.cssText = `
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-image: url('${thumbnail.src}');
          background-size: cover;
          background-position: center;
          cursor: pointer;
          z-index: 10;
          transition: opacity 0.3s ease;
        `;
        
        // Play-Button hinzufügen (kleiner, eleganter)
        const playButton = document.createElement('div');
        playButton.innerHTML = `
          <svg fill="none" width="40" height="40" viewBox="0 0 48 48" style="filter: drop-shadow(0 2px 4px rgba(0,0,0,0.2));">
            <circle cx="24" cy="24" r="23" fill="transparent" stroke="black" stroke-width="2"/>
            <path d="M18.578 32.629a.375.375 0 0 1-.578-.316V15.687c0-.297.328-.476.578-.316l12.931 8.314c.23.147.23.483 0 .63L18.578 32.63Z" fill="black"/>
          </svg>
        `;
        playButton.style.cssText = `
          position: absolute;
          bottom: 12px;
          left: 12px;
          pointer-events: none;
          transition: transform 0.2s ease;
        `;
        
        thumbnailOverlay.appendChild(playButton);
        videoMedia.appendChild(thumbnailOverlay);
        
        console.log('✅ Thumbnail-Overlay mit Play-Button erstellt');
      }
      
      function createPlayButtonOverlay() {
        // Nur erstellen falls noch nicht vorhanden
        if (playButtonOverlay) {
          console.log('ℹ️ Play-Button-Overlay bereits vorhanden');
          return;
        }
        
        console.log('▶️ Erstelle Play-Button-Overlay für pausiertes Video...');
        
        // Play-Button-Overlay erstellen (transparent background)
        playButtonOverlay = document.createElement('div');
        playButtonOverlay.style.cssText = `
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: transparent;
          cursor: pointer;
          z-index: 15;
          display: flex;
          align-items: flex-end;
          justify-content: flex-start;
          padding: 12px;
          transition: opacity 0.2s ease;
        `;
        
        // Play-Button hinzufügen (kleiner, eleganter - gleich wie Thumbnail)
        const playButton = document.createElement('div');
        playButton.innerHTML = `
          <svg fill="none" width="40" height="40" viewBox="0 0 48 48" style="filter: drop-shadow(0 2px 4px rgba(0,0,0,0.2));">
            <circle cx="24" cy="24" r="23" fill="transparent" stroke="black" stroke-width="2"/>
            <path d="M18.578 32.629a.375.375 0 0 1-.578-.316V15.687c0-.297.328-.476.578-.316l12.931 8.314c.23.147.23.483 0 .63L18.578 32.63Z" fill="black"/>
          </svg>
        `;
        playButton.style.cssText = `
          pointer-events: none;
          transition: transform 0.2s ease;
        `;
        
        playButtonOverlay.appendChild(playButton);
        videoMedia.appendChild(playButtonOverlay);
        
        console.log('✅ Play-Button-Overlay für pausiertes Video erstellt');
      }
      
      function showPlayButtonOverlay() {
        if (!playButtonOverlay) {
          createPlayButtonOverlay();
        }
        if (playButtonOverlay) {
          playButtonOverlay.style.display = 'flex';
          console.log('👁️ Play-Button-Overlay angezeigt');
        }
      }
      
      function hidePlayButtonOverlay() {
        if (playButtonOverlay) {
          playButtonOverlay.style.display = 'none';
          console.log('🙈 Play-Button-Overlay versteckt');
        }
      }
      
      // Hover-to-Play für Desktop
      if (window.matchMedia('(min-width: 768px) and (hover: hover)').matches) {
        videoMedia.addEventListener('mouseenter', function() {
          console.log('🖱️ Vimeo Hover - Play');
          
          // Thumbnail-Overlay entfernen falls noch vorhanden
          if (thumbnailOverlay) {
            console.log('🖼️ Entferne Thumbnail-Overlay');
            thumbnailOverlay.style.opacity = '0';
            setTimeout(() => {
              if (thumbnailOverlay && thumbnailOverlay.parentNode) {
                thumbnailOverlay.parentNode.removeChild(thumbnailOverlay);
                thumbnailOverlay = null;
              }
            }, 300);
          }
          
          // Play-Button-Overlay verstecken (Video läuft)
          hidePlayButtonOverlay();
          
          // Einfach: Video starten/fortsetzen
          videoMedia.play();
          isPlaying = true;
          console.log('▶️ Video play getriggert');
        });
        
        videoMedia.addEventListener('mouseleave', function() {
          console.log('🖱️ Mouse Leave - Pause');
          
          // Einfach: Video pausieren
          videoMedia.pause();
          isPlaying = false;
          
          // Play-Button-Overlay anzeigen (Video ist pausiert)
          showPlayButtonOverlay();
          
          console.log('⏸️ Video pause getriggert');
        });
      }
      
      // Click-to-Play für Mobile
      else {
        videoMedia.addEventListener('click', function() {
          console.log('📱 Mobile Click - Play/Pause Toggle');
          
          if (!isPlaying) {
            // Video starten
            console.log('▶️ Mobile: Video starten');
            
            // Thumbnail-Overlay entfernen falls noch vorhanden
            if (thumbnailOverlay) {
              console.log('🖼️ Entferne Thumbnail-Overlay (Mobile)');
              thumbnailOverlay.style.opacity = '0';
              setTimeout(() => {
                if (thumbnailOverlay && thumbnailOverlay.parentNode) {
                  thumbnailOverlay.parentNode.removeChild(thumbnailOverlay);
                  thumbnailOverlay = null;
                }
              }, 300);
            }
            
            // Play-Button-Overlay verstecken
            hidePlayButtonOverlay();
            
            // Video starten
            videoMedia.play();
            isPlaying = true;
            console.log('▶️ Mobile: Video gestartet');
            
          } else {
            // Video pausieren
            console.log('⏸️ Mobile: Video pausieren');
            videoMedia.pause();
            isPlaying = false;
            
            // Play-Button-Overlay anzeigen
            showPlayButtonOverlay();
            console.log('⏸️ Mobile: Video pausiert');
          }
        });
      }
      
    });
  }
});

/* ========================================
   BUNDLE PRODUCTS FUNCTIONALITY
   ======================================== */

const BundleProducts = {
  async init() {
    const bundleSelector = document.querySelector('[data-bundle-selector]');
    if (!bundleSelector) return;

    this.bundleSelector = bundleSelector;
    this.productId = bundleSelector.dataset.productId;
    this.variantId = bundleSelector.dataset.variantId;
    this.optionName = bundleSelector.dataset.optionName;
    this.optionMetafield = bundleSelector.dataset.optionMetafield;
    this.selectorStyle = bundleSelector.dataset.selectorStyle || 'block';
    this.discountCode = bundleSelector.dataset.bundleDiscountCode || null;
    
    this.bundleData = {
      components: [],
      selectedProducts: []
    };

    // Lade Bundle-Komponenten über Storefront API
    await this.loadBundleComponents();
  },

  async loadBundleComponents() {
    try {
      // Versuche zuerst Storefront API
      const components = await this.fetchBundleComponents(this.variantId);
      
      if (!components || components.length === 0) {
        await this.loadBundleComponentsFromMetafield();
        return;
      }

      this.bundleData.components = components;

      // STUFE 1: Zeige sofort die Basis-Produkte (schnell) 🚀
      this.renderBundleUI(false); // false = ohne Varianten-Selektoren
      this.initBuyButton();
      
      // Trigger initial price calculation
      document.dispatchEvent(new CustomEvent('bundle:initial-load'));

      // STUFE 2: Lade Varianten im Hintergrund nach (non-blocking)
      requestAnimationFrame(async () => {
        await this.loadVariationProducts();
        
        // Update UI mit Varianten-Selektoren
        this.renderBundleUI(true); // true = mit Varianten-Selektoren
        this.initVariantSelectors();
        
        // Re-init Buy Button nach Varianten-Laden (wichtig!)
        this.initBuyButton();
        
        // Update price nach Varianten-Laden
        document.dispatchEvent(new CustomEvent('bundle:variants-loaded'));
      });

    } catch (error) {
      console.error('❌ Fehler beim Laden der Bundle-Komponenten:', error);
      
      // Fallback-Methode
      try {
        await this.loadBundleComponentsFromMetafield();
      } catch (fallbackError) {
        console.error('❌ Auch Fallback fehlgeschlagen:', fallbackError);
        this.showError('Bundle konnte nicht geladen werden. Bitte erstellen Sie ein Storefront API Token.');
      }
    }
  },

  async loadBundleComponentsFromMetafield() {
    // TODO: Fallback-Implementierung mit Metafields
    // Für jetzt zeigen wir nur die Fehlermeldung mit Anleitung
    this.showError('Storefront API Token erforderlich. Bitte siehe Dokumentation.');
  },

  async fetchBundleComponents(variantId) {
    // Maximal optimierte Query: nur absolut nötige Felder, sehr kleine Bilder
    const query = `
      query getBundleComponents($id: ID!) {
        node(id: $id) {
          ... on ProductVariant {
            id
            components(first: 20) {
              nodes {
                productVariant {
                  id
                  price {
                    amount
                  }
                  compareAtPrice {
                    amount
                  }
                  image {
                    url(transform: { maxWidth: 140, maxHeight: 140, crop: CENTER })
                  }
                  product {
                    id
                    title
                    productType
                    metafield(namespace: "custom", key: "variation_products") {
                      value
                    }
                  }
                }
              }
            }
          }
        }
      }
    `;

    const gid = `gid://shopify/ProductVariant/${variantId}`;

    const response = await fetch('/api/2024-10/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': window.Shopify?.storefrontAccessToken || ''
      },
      body: JSON.stringify({
        query,
        variables: {
          id: gid
        }
      })
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error('❌ Bundle API Error:', response.status, errorText.substring(0, 100));
      throw new Error(`Storefront API Anfrage fehlgeschlagen`);
    }

    const data = await response.json();
    
    if (data.errors) {
      console.error('❌ GraphQL Errors:', data.errors);
      throw new Error(data.errors[0].message);
    }

    const components = data.data?.node?.components?.nodes || [];

    return components;
  },

  async loadVariationProducts() {
    // Sammle ALLE Product-IDs aus allen Komponenten
    const allProductIds = [];
    const componentIndexMap = new Map(); // Mapping: productId -> componentIndex
    
    this.bundleData.components.forEach((component, index) => {
      const product = component.productVariant.product;
      const metafield = product.metafield;

      if (!metafield || !metafield.value) return;

      try {
        const variationProductIds = JSON.parse(metafield.value);
        variationProductIds.forEach(id => {
          if (!componentIndexMap.has(id)) {
            componentIndexMap.set(id, []);
            allProductIds.push(id);
          }
          componentIndexMap.get(id).push(index);
        });
      } catch (error) {
        console.error(`❌ Fehler beim Parsen der Variation-Products für Komponente ${index}:`, error);
      }
    });

    if (allProductIds.length === 0) return;

    // EIN API-Call für ALLE Produkte auf einmal! 🚀
    const allVariationProducts = await this.fetchProductsByIds(allProductIds);
    
    // Verteile die geladenen Produkte auf die Komponenten
    this.bundleData.components = this.bundleData.components.map((component, index) => {
      const product = component.productVariant.product;
      const metafield = product.metafield;
      
      if (!metafield || !metafield.value) {
        return component;
      }

      try {
        const variationProductIds = JSON.parse(metafield.value);
        const variationProducts = variationProductIds
          .map(id => allVariationProducts.find(p => p.id === id))
          .filter(p => p !== undefined);
        
        return {
          ...component,
          variationProducts
        };
      } catch (error) {
        return component;
      }
    });
  },

  async fetchProductsByIds(productIds) {
    if (!productIds || productIds.length === 0) return [];

    // Maximal optimierte Query: nur absolut nötige Felder, sehr kleine Bilder
    const query = `
      query getProducts($ids: [ID!]!) {
        nodes(ids: $ids) {
          ... on Product {
            id
            title
            productType
            featuredImage {
              url(transform: { maxWidth: 140, maxHeight: 140, crop: CENTER })
            }
            variants(first: 1) {
              nodes {
                id
                price {
                  amount
                }
                compareAtPrice {
                  amount
                }
              }
            }
            metafield(namespace: "custom", key: "variation_value") {
              value
            }
            productRanking: metafield(namespace: "custom", key: "product_ranking") {
              value
            }
          }
        }
      }
    `;

    // Konvertiere Product IDs zu GIDs
    const gids = productIds.map(id => `gid://shopify/Product/${id.replace('gid://shopify/Product/', '')}`);

    const response = await fetch('/api/2024-10/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': window.Shopify?.storefrontAccessToken || ''
      },
      body: JSON.stringify({
        query,
        variables: { ids: gids }
      })
    });

    if (!response.ok) {
      console.error('❌ Variation Products API Error:', response.status);
      throw new Error(`Fehler beim Laden der Variation-Products`);
    }

    const data = await response.json();
    
    if (data.errors) {
      console.error('❌ Variation Products Errors:', data.errors[0]?.message);
    }
    
    return data.data?.nodes?.filter(node => node !== null) || [];
  },

  renderBundleUI(withVariants = true) {
    const loadingEl = this.bundleSelector.querySelector('.bundle-loading');
    const listEl = this.bundleSelector.querySelector('.bundle-products-list');
    
    if (loadingEl) loadingEl.style.display = 'none';
    if (!listEl) return;

    // Exakte Theme-Struktur: product-info__product-picker für jede Komponente
    listEl.innerHTML = `
      <div class="v-stack gap-6">
        <h3 class="h5">Diese Produkte sind im Set enthalten:</h3>
        ${this.bundleData.components.map((component, index) => this.renderComponent(component, index, withVariants)).join('')}
      </div>
    `;

    listEl.style.display = 'block';
  },

  renderComponent(component, index, withVariants = true) {
    const variant = component.productVariant;
    const product = variant.product;
    const variationProducts = component.variationProducts || [];
    
    // Sortiere Varianten nach Product Ranking für Standardauswahl
    let currentProduct;
    if (variationProducts.length > 0) {
      const sortedVariations = [...variationProducts].sort((a, b) => {
        const rankingA = parseInt(a.productRanking?.value) || 9999;
        const rankingB = parseInt(b.productRanking?.value) || 9999;
        
        if (rankingA !== rankingB) {
          return rankingA - rankingB;
        }
        
        // Fallback: Alphabetisch nach Titel
        const titleA = a.metafield?.value || a.title || '';
        const titleB = b.metafield?.value || b.title || '';
        return titleA.localeCompare(titleB);
      });
      
      // Nimm immer das erste (nach Ranking sortierte) Produkt als Standard
      currentProduct = sortedVariations[0];
    }

    // Speichere initial ausgewählte Variante (nur wenn noch keine Auswahl existiert!)
    if (currentProduct && currentProduct.variants.nodes[0] && !this.bundleData.selectedProducts[index]) {
      this.bundleData.selectedProducts[index] = {
        variantId: currentProduct.variants.nodes[0].id.replace('gid://shopify/ProductVariant/', ''),
        price: parseFloat(currentProduct.variants.nodes[0].price.amount) * 100,
        comparePrice: currentProduct.variants.nodes[0].compareAtPrice 
          ? parseFloat(currentProduct.variants.nodes[0].compareAtPrice.amount) * 100 
          : 0,
        name: currentProduct.metafield?.value || currentProduct.title,
        image: currentProduct.featuredImage?.url || variant.image?.url,
        productType: currentProduct.productType || ''
      };
    }
    
    // Verwende gespeicherte Auswahl falls vorhanden (für Display)
    const selectedProduct = this.bundleData.selectedProducts[index];
    const displayImage = selectedProduct?.image || variant.image?.url;
    const displayTitle = selectedProduct?.name || product.title;
    const displayPrice = selectedProduct?.price || (parseFloat(variant.price.amount) * 100);
    const displayProductType = selectedProduct?.productType || product.productType || '';

    return `
      <div data-bundle-product-index="${index}">
        <div class="h-stack gap-4 align-start">
          ${displayImage ? `
            <img 
              src="${displayImage}" 
              alt="${displayTitle}"
              width="140"
              height="140"
              loading="lazy"
              class="rounded-xs"
              style="flex-shrink: 0;">
          ` : ''}
          
          <div class="v-stack gap-2" style="flex: 1; min-width: 0;">
            <h4 class="h6 bundle-product-title">${displayTitle}</h4>
            ${displayProductType ? `
              <p class="text-subdued text-sm bundle-product-type">${displayProductType}</p>
            ` : ''}
            <div class="price text-subdued bundle-product-price">
              ${this.formatMoney(displayPrice)}
            </div>

            ${withVariants && variationProducts.length > 1 ? `
              <div class="product-info__product-picker" style="width: 100%;">
                <div class="variant-picker custom-variant-picker">
                  <fieldset class="variant-picker__option">
                    ${this.renderVariantSelector(variationProducts, selectedProduct, index)}
                  </fieldset>
                </div>
              </div>
            ` : (variationProducts.length > 1 ? `
              <div style="width: 100%;">
                <div class="skeleton-loader" style="height: 48px; border-radius: 6px;"></div>
              </div>
            ` : '')}
          </div>
        </div>
      </div>
    `;
  },

  renderVariantSelector(variations, selectedProduct, componentIndex) {
    const [namespace, key] = this.optionMetafield.split('.');
    
    // Sortiere Varianten nach Product Ranking (niedrigere Werte zuerst)
    const sortedVariations = [...variations].sort((a, b) => {
      const rankingA = parseInt(a.productRanking?.value) || 9999;
      const rankingB = parseInt(b.productRanking?.value) || 9999;
      
      if (rankingA !== rankingB) {
        return rankingA - rankingB;
      }
      
      // Fallback: Alphabetisch nach Titel
      const titleA = a.metafield?.value || a.title || '';
      const titleB = b.metafield?.value || b.title || '';
      return titleA.localeCompare(titleB);
    });
    
    // Finde die aktuell ausgewählte Variation basierend auf variantId
    let selectedVariation = sortedVariations[0];
    if (selectedProduct?.variantId) {
      selectedVariation = sortedVariations.find(v => 
        v.variants.nodes[0].id.replace('gid://shopify/ProductVariant/', '') === selectedProduct.variantId
      ) || sortedVariations[0];
    }

    switch (this.selectorStyle) {
      case 'dropdown':
        // Theme-native Dropdown Style (popover-basiert)
        const selectedValue = selectedVariation.metafield?.value || selectedVariation.title;
        
        return `
          <div class="relative">
            <button
              type="button"
              class="select bundle-variant-select"
              data-component-index="${componentIndex}"
              aria-expanded="false">
              <span class="bundle-selected-value">${selectedValue}</span>
              <svg class="select-chevron" width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 1L5 5L9 1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
            <div class="bundle-dropdown-options" style="display: none;">
              ${sortedVariations.map(variation => {
                const variant = variation.variants.nodes[0];
                const variationValue = variation.metafield?.value || variation.title;
                const isSelected = variation.id === selectedVariation.id;
                
                return `
                  <button
                    type="button"
                    class="bundle-dropdown-option ${isSelected ? 'is-selected' : ''}"
                    data-component-index="${componentIndex}"
                    data-variant-id="${variant.id.replace('gid://shopify/ProductVariant/', '')}"
                    data-variant-price="${parseFloat(variant.price.amount) * 100}"
                    data-variant-compare-price="${variant.compareAtPrice ? parseFloat(variant.compareAtPrice.amount) * 100 : 0}"
                    data-variant-name="${variationValue}"
                    data-variant-image="${variation.featuredImage?.url || ''}"
                    data-variant-product-type="${variation.productType || ''}">
                    ${variationValue}
                  </button>
                `;
              }).join('')}
            </div>
          </div>
        `;

      case 'variant_image':
        // Theme-native Structure with Navigation - genau wie im Theme!
        return `
          <div class="variant-picker__option-values-wrapper">
            <button class="variant-picker__nav-btn left">
              <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 1L7 7L1 13" stroke="black" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
            <div class="variant-picker__option-values wrap gap-2">
              ${sortedVariations.map(variation => {
                const variant = variation.variants.nodes[0];
                const variationValue = variation.metafield?.value || variation.title;
                const isSelected = variation.id === selectedVariation.id;
                const imageUrl = variation.featuredImage?.url || '';
                
                return `
                  <a
                    href="javascript:void(0)"
                    class="thumbnail-swatch border ${isSelected ? 'is-selected' : ''}"
                    data-component-index="${componentIndex}"
                    data-variant-id="${variant.id.replace('gid://shopify/ProductVariant/', '')}"
                    data-variant-price="${parseFloat(variant.price.amount) * 100}"
                    data-variant-compare-price="${variant.compareAtPrice ? parseFloat(variant.compareAtPrice.amount) * 100 : 0}"
                    data-variant-name="${variationValue}"
                    data-variant-image="${imageUrl}"
                    data-variant-product-type="${variation.productType || ''}">
                    <span class="sr-only">${variationValue}</span>
                    <img 
                      src="${imageUrl}" 
                      alt="${variationValue}"
                      loading="lazy"
                      sizes="60px"
                      class="object-cover">
                  </a>
                `;
              }).join('')}
            </div>
            <button class="variant-picker__nav-btn right">
              <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 1L7 7L1 13" stroke="black" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
          </div>
        `;

      case 'swatch':
        // Theme-native Swatch with Navigation
        return `
          <div class="variant-picker__option-values-wrapper">
            <button class="variant-picker__nav-btn left">
              <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 1L7 7L1 13" stroke="black" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
            <div class="variant-picker__option-values wrap gap-2">
              ${sortedVariations.map(variation => {
                const variant = variation.variants.nodes[0];
                const variationValue = variation.metafield?.value || variation.title;
                const isSelected = variation.id === selectedVariation.id;
                const colorSwatch = variationValue.toLowerCase().replace(/\s+/g, '-');
                
                return `
                  <button
                    type="button"
                    class="color-swatch ${isSelected ? 'is-selected' : ''}"
                    data-component-index="${componentIndex}"
                    data-variant-id="${variant.id.replace('gid://shopify/ProductVariant/', '')}"
                    data-variant-price="${parseFloat(variant.price.amount) * 100}"
                    data-variant-compare-price="${variant.compareAtPrice ? parseFloat(variant.compareAtPrice.amount) * 100 : 0}"
                    data-variant-name="${variationValue}"
                    data-variant-image="${variation.featuredImage?.url || ''}"
                    data-variant-product-type="${variation.productType || ''}"
                    style="--swatch-background: linear-gradient(to right, ${colorSwatch}, ${colorSwatch})"
                    aria-label="${variationValue}">
                    <span class="sr-only">${variationValue}</span>
                  </button>
                `;
              }).join('')}
            </div>
            <button class="variant-picker__nav-btn right">
              <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 1L7 7L1 13" stroke="black" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
          </div>
        `;

      default: // 'block'
        // Theme-native Block Style with Navigation
        return `
          <div class="variant-picker__option-values-wrapper">
            <button class="variant-picker__nav-btn left">
              <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 1L7 7L1 13" stroke="black" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
            <div class="variant-picker__option-values wrap gap-2">
              ${sortedVariations.map(variation => {
                const variant = variation.variants.nodes[0];
                const variationValue = variation.metafield?.value || variation.title;
                const isSelected = variation.id === selectedVariation.id;
                
                return `
                  <button
                    type="button"
                    class="block-swatch ${isSelected ? 'is-selected' : ''}"
                    data-component-index="${componentIndex}"
                    data-variant-id="${variant.id.replace('gid://shopify/ProductVariant/', '')}"
                    data-variant-price="${parseFloat(variant.price.amount) * 100}"
                    data-variant-compare-price="${variant.compareAtPrice ? parseFloat(variant.compareAtPrice.amount) * 100 : 0}"
                    data-variant-name="${variationValue}"
                    data-variant-image="${variation.featuredImage?.url || ''}"
                    data-variant-product-type="${variation.productType || ''}">
                    <span>${variationValue}</span>
                  </button>
                `;
              }).join('')}
            </div>
            <button class="variant-picker__nav-btn right">
              <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 1L7 7L1 13" stroke="black" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
          </div>
        `;
    }
  },

  showError(message) {
    const loadingEl = this.bundleSelector.querySelector('.bundle-loading');
    const errorEl = this.bundleSelector.querySelector('.bundle-error');
    
    if (loadingEl) loadingEl.style.display = 'none';
    if (errorEl) {
      errorEl.querySelector('p').textContent = message;
      errorEl.style.display = 'block';
    }
  },

  initVariantSelectors() {
    // Dropdown Select Buttons (Theme-native Style)
    const dropdownButtons = document.querySelectorAll('.bundle-variant-select');
    dropdownButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        const dropdown = button.closest('.relative');
        const options = dropdown.querySelector('.bundle-dropdown-options');
        
        // Toggle dropdown
        const isOpen = options.style.display === 'block';
        options.style.display = isOpen ? 'none' : 'block';
        button.setAttribute('aria-expanded', !isOpen);
      });
    });

    // Dropdown Options
    const dropdownOptions = document.querySelectorAll('.bundle-dropdown-option');
    dropdownOptions.forEach(option => {
      option.addEventListener('click', (e) => {
        e.preventDefault();
        this.handleDropdownOptionClick(e.currentTarget);
      });
    });

    // Swatch, Thumbnail & Block Buttons (Theme-native Klassen)
    const swatches = document.querySelectorAll('.color-swatch, .thumbnail-swatch, .block-swatch');
    swatches.forEach(swatch => {
      // Nur Bundle-Selektoren
      if (swatch.closest('[data-bundle-product-index]')) {
        swatch.addEventListener('click', (e) => {
          e.preventDefault();
          this.handleSwatchClick(e.currentTarget);
        });
      }
    });

    // Navigationspfeile für Bundle-Varianten
    const bundleNavButtons = document.querySelectorAll('[data-bundle-product-index] .variant-picker__nav-btn');
    bundleNavButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        const wrapper = button.closest('.variant-picker__option-values-wrapper');
        const container = wrapper.querySelector('.variant-picker__option-values');
        const scrollAmount = 200;
        
        if (button.classList.contains('left')) {
          container.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
        } else {
          container.scrollBy({ left: scrollAmount, behavior: 'smooth' });
        }
      });
    });

    // Close dropdowns when clicking outside
    document.addEventListener('click', (e) => {
      if (!e.target.closest('.relative')) {
        document.querySelectorAll('.bundle-dropdown-options').forEach(opt => {
          opt.style.display = 'none';
        });
        document.querySelectorAll('.bundle-variant-select').forEach(btn => {
          btn.setAttribute('aria-expanded', 'false');
        });
      }
    });
  },

  handleDropdownOptionClick(option) {
    const componentIndex = parseInt(option.dataset.componentIndex);
    const variantData = this.getVariantDataFromElement(option);
    
    // Update button text
    const dropdown = option.closest('.relative');
    const button = dropdown.querySelector('.bundle-variant-select');
    const valueSpan = button.querySelector('.bundle-selected-value');
    valueSpan.textContent = variantData.name;
    
    // Mark as selected
    dropdown.querySelectorAll('.bundle-dropdown-option').forEach(opt => {
      opt.classList.remove('is-selected');
    });
    option.classList.add('is-selected');
    
    // Close dropdown
    dropdown.querySelector('.bundle-dropdown-options').style.display = 'none';
    button.setAttribute('aria-expanded', 'false');
    
    // Update product selection
    this.updateProductSelection(componentIndex, variantData);
    this.updateProductDisplay(option.closest('[data-bundle-product-index]'), variantData);
    
    // Trigger Event für Price Calculator
    document.dispatchEvent(new CustomEvent('bundle:variant-changed', {
      detail: { componentIndex, variantData }
    }));
  },

  handleVariantChange(dropdown) {
    const componentIndex = parseInt(dropdown.dataset.componentIndex);
    const selectedOption = dropdown.options[dropdown.selectedIndex];
    const variantData = this.getVariantDataFromElement(selectedOption);
    
    this.updateProductSelection(componentIndex, variantData);
    this.updateProductDisplay(dropdown.closest('[data-bundle-product-index]'), variantData);
  },

  handleSwatchClick(swatch) {
    const componentIndex = parseInt(swatch.dataset.componentIndex);
    const variantData = this.getVariantDataFromElement(swatch);
    
    // Alle Swatches der gleichen Gruppe deselektieren (Theme-native Klassen)
    const swatchContainer = swatch.closest('.variant-picker__option-values');
    swatchContainer.querySelectorAll('.color-swatch, .thumbnail-swatch, .block-swatch').forEach(s => {
      s.classList.remove('is-selected');
    });
    
    // Aktuellen Swatch selektieren
    swatch.classList.add('is-selected');
    
    this.updateProductSelection(componentIndex, variantData);
    this.updateProductDisplay(swatch.closest('[data-bundle-product-index]'), variantData);
    
    // Trigger Event für Price Calculator
    document.dispatchEvent(new CustomEvent('bundle:variant-changed', {
      detail: { componentIndex, variantData }
    }));
  },

  getVariantDataFromElement(element) {
    return {
      variantId: element.dataset.variantId,
      price: parseFloat(element.dataset.variantPrice),
      comparePrice: parseFloat(element.dataset.variantComparePrice || 0),
      name: element.dataset.variantName,
      image: element.dataset.variantImage,
      productType: element.dataset.variantProductType || ''
    };
  },

  updateProductSelection(index, variantData) {
    this.bundleData.selectedProducts[index] = variantData;
  },

  updateProductDisplay(productItem, variantData) {
    if (!productItem) return;
    
    // Update Produktbild (erstes img im h-stack)
    const productImage = productItem.querySelector('.h-stack img');
    if (productImage && variantData.image) {
      productImage.src = variantData.image;
      productImage.alt = variantData.name || '';
    }
    
    // Update Produkttitel
    const titleDisplay = productItem.querySelector('.bundle-product-title');
    if (titleDisplay && variantData.name) {
      titleDisplay.textContent = variantData.name;
    }
    
    // Update Produkttyp
    const productTypeDisplay = productItem.querySelector('.bundle-product-type');
    if (productTypeDisplay && variantData.productType) {
      productTypeDisplay.textContent = variantData.productType;
    }
    
    // Update Preis
    const priceDisplay = productItem.querySelector('.bundle-product-price');
    if (priceDisplay && variantData.price) {
      priceDisplay.textContent = this.formatMoney(variantData.price);
    }
  },

  calculateTotalPrice() {
    let totalPrice = 0;
    let totalComparePrice = 0;
    
    this.bundleData.selectedProducts.forEach(product => {
      if (product && product.price) {
        totalPrice += product.price;
        if (product.comparePrice && product.comparePrice > 0) {
          totalComparePrice += product.comparePrice;
        }
      }
    });

    // Der Rabatt ergibt sich aus Compare-Preisen (wenn vorhanden)
    let finalPrice = totalPrice;
    let savedAmount = 0;
    
    if (totalComparePrice > totalPrice) {
      savedAmount = totalComparePrice - totalPrice;
    }

    this.updatePriceDisplay(finalPrice, totalComparePrice, savedAmount);
  },

  updatePriceDisplay(finalPrice, comparePrice, savedAmount) {
    const finalPriceEl = document.querySelector('.bundle-final-price');
    const comparePriceEl = document.querySelector('.bundle-compare-price');
    const savingsEl = document.querySelector('.bundle-savings');
    const savingsAmountEl = document.querySelector('.bundle-savings-amount');
    
    if (finalPriceEl) {
      finalPriceEl.textContent = this.formatMoney(finalPrice);
    }
    
    if (comparePriceEl && savedAmount > 0) {
      comparePriceEl.textContent = this.formatMoney(comparePrice);
      comparePriceEl.style.display = 'inline';
    } else if (comparePriceEl) {
      comparePriceEl.style.display = 'none';
    }
    
    if (savingsEl && savingsAmountEl && savedAmount > 0) {
      savingsAmountEl.textContent = this.formatMoney(savedAmount);
      savingsEl.style.display = 'block';
    } else if (savingsEl) {
      savingsEl.style.display = 'none';
    }
  },

  initBuyButton() {
    // Prüfe ob Bundle-Produkt
    if (!this.bundleSelector || this.bundleData.components.length === 0) {
      console.log('⚠️ Kein Bundle-Produkt oder keine Komponenten');
      return;
    }

    console.log('🎯 Init Buy Button für Bundle');

    // Finde ALLE möglichen Forms
    const productForms = document.querySelectorAll('form[action*="/cart/add"]');
    console.log('📋 Gefundene Forms:', productForms.length);

    if (productForms.length === 0) {
      console.warn('❌ Kein Product Form gefunden!');
      return;
    }

    productForms.forEach((form, index) => {
      console.log(`  → Form ${index}:`, form);
      
      // Entferne Standard-Submit-Handler
      form.addEventListener('submit', (e) => {
        console.log('🚫 Form Submit abgefangen!');
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        
        const submitButton = form.querySelector('button[type="submit"], button[name="add"]');
        this.addBundleToCart(submitButton);
        
        return false;
      }, true); // Capture phase
      
      // Zusätzlich: Deaktiviere den default submit handler
      form.onsubmit = (e) => {
        console.log('🚫 onsubmit abgefangen!');
        e.preventDefault();
        const submitButton = form.querySelector('button[type="submit"], button[name="add"]');
        this.addBundleToCart(submitButton);
        return false;
      };
    });
  },

  async addBundleToCart(buyButton) {
    if (!buyButton) return;

    // Button deaktivieren während des Hinzufügens
    buyButton.setAttribute('disabled', 'disabled');
    buyButton.setAttribute('aria-busy', 'true');
    
    const originalText = buyButton.textContent;
    buyButton.textContent = 'Wird hinzugefügt...';

    try {
      // Debug: Zeige was aktuell ausgewählt ist
      console.log('🛒 Selected Products:', this.bundleData.selectedProducts);
      
      // Generiere eindeutige Bundle-ID für Gruppierung im Cart
      const bundleId = `bundle-${Date.now()}`;
      const bundleTitle = document.querySelector('.product__title')?.textContent?.trim() || 'Bundle';
      
      // Erstelle ein Array mit allen ausgewählten Bundle-Komponenten
      const items = this.bundleData.selectedProducts
        .filter(product => product && product.variantId)
        .map((product, index) => {
          console.log(`  → Adding: ${product.name} (ID: ${product.variantId})`);
          return {
            id: product.variantId,
            quantity: 1,
            properties: {
              '_bundle_id': bundleId,
              '_bundle_title': bundleTitle,
              '_bundle_component': `${index + 1} von ${this.bundleData.selectedProducts.length}`
            }
          };
        });

      console.log('🛒 Items to add:', items);

      if (items.length === 0) {
        throw new Error('Keine Produkte ausgewählt');
      }

      // Baue Cart Add URL - mit Discount Code falls vorhanden
      let cartAddUrl = '/cart/add.js';
      if (this.discountCode) {
        cartAddUrl += `?discount=${encodeURIComponent(this.discountCode)}`;
        console.log(`🎟️ Füge Rabattcode hinzu: ${this.discountCode}`);
      }

      // Verwende die Shopify Cart API um mehrere Produkte gleichzeitig hinzuzufügen (mit Discount!)
      const response = await fetch(cartAddUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ items })
      });

      if (!response.ok) {
        throw new Error('Fehler beim Hinzufügen zum Warenkorb');
      }

      const responseData = await response.json();

      // Hole Cart-Daten mit Section Rendering (genau wie das Theme)
      const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`);
      const cartData = await cartResponse.json();
      
      // Hole die Cart Drawer Section für Update
      const cartDrawerElement = document.querySelector('cart-drawer');
      const shopifySection = cartDrawerElement.closest('.shopify-section');
      const sectionId = shopifySection ? shopifySection.id.replace('shopify-section-', '') : 'cart-drawer';
      
      const sectionsResponse = await fetch(`${window.Shopify.routes.root}?sections=${sectionId}`);
      const sections = await sectionsResponse.json();
      
      cartData['sections'] = sections;

      // Trigger Theme-native Events (genau wie bei normalem ATC)
      document.documentElement.dispatchEvent(
        new CustomEvent('variant:add', {
          bubbles: true,
          detail: {
            items: responseData.items || [responseData],
            cart: cartData
          }
        })
      );

      document.documentElement.dispatchEvent(
        new CustomEvent('cart:change', {
          bubbles: true,
          detail: {
            baseEvent: 'variant:add',
            cart: cartData
          }
        })
      );

      // Öffne Cart Drawer
      setTimeout(() => {
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        }
      }, 50);

      // Success Feedback
      buyButton.textContent = '✓ Hinzugefügt!';
      setTimeout(() => {
        buyButton.textContent = originalText;
        buyButton.removeAttribute('disabled');
        buyButton.removeAttribute('aria-busy');
      }, 2000);

    } catch (error) {
      console.error('❌ Fehler beim Hinzufügen des Bundles:', error);
      
      // Error Feedback
      buyButton.textContent = 'Fehler - Bitte erneut versuchen';
      setTimeout(() => {
        buyButton.textContent = originalText;
        buyButton.removeAttribute('disabled');
        buyButton.removeAttribute('aria-busy');
      }, 3000);
    }
  },

  formatMoney(cents) {
    // Shopify Money Format
    const amount = cents / 100;
    return new Intl.NumberFormat('de-DE', {
      style: 'currency',
      currency: 'EUR'
    }).format(amount);
  }
};

// Bundle Price Calculator - Berechnet Bundle-Preis dynamisch
const BundlePriceCalculator = {
  init() {
    const bundleSelector = document.querySelector('[data-bundle-selector]');
    if (!bundleSelector) return;
    
    // Update bei Initial Load
    document.addEventListener('bundle:initial-load', () => {
      this.updateBundlePrice();
    });
    
    // Update bei Varianten-Wechsel
    document.addEventListener('bundle:variant-changed', () => {
      this.updateBundlePrice();
    });
    
    // Update nach Varianten geladen
    document.addEventListener('bundle:variants-loaded', () => {
      this.updateBundlePrice();
    });
  },
  
  updateBundlePrice() {
    const bundleSelector = document.querySelector('[data-bundle-selector]');
    if (!bundleSelector) return;
    
    // Safety Check: Warte bis Bundle-Daten verfügbar sind
    if (!BundleProducts.bundleData || !BundleProducts.bundleData.selectedProducts) {
      console.log('⚠️ Bundle-Daten noch nicht verfügbar');
      return;
    }
    
    // Hole Rabatt aus Metafeld (Format: Prozentsatz, z.B. 10 = 10%)
    const discountPercentage = parseFloat(bundleSelector.dataset.bundleDiscountAmount) || 0;
    
    // Berechne Summe aller ausgewählten Bundle-Komponenten
    let totalPrice = 0;
    let totalComparePrice = 0;
    
    BundleProducts.bundleData.selectedProducts.forEach(product => {
      if (product && product.price) {
        totalPrice += product.price;
        totalComparePrice += product.comparePrice || product.price;
      }
    });
    
    // Mindestens 1 Produkt muss ausgewählt sein
    if (totalPrice === 0) {
      console.log('⚠️ Keine Produkte ausgewählt oder Preise noch nicht geladen');
      return;
    }
    
    // Berechne prozentualen Rabatt
    const discountAmount = Math.round(totalPrice * (discountPercentage / 100));
    const finalPrice = Math.max(0, totalPrice - discountAmount);
    
    // Update Price-List Elements
    const priceList = document.querySelector('.product-info__price price-list');
    if (!priceList) return;
    
    const salePrice = priceList.querySelector('sale-price');
    const comparePrice = priceList.querySelector('compare-at-price');
    
    if (salePrice) {
      salePrice.textContent = this.formatMoney(finalPrice);
      
      // Zeige als Sale-Preis wenn Rabatt vorhanden
      if (discountAmount > 0) {
        salePrice.className = 'text-lg text-on-sale';
      } else {
        salePrice.className = 'text-lg';
      }
    }
    
    if (comparePrice) {
      if (discountAmount > 0 && totalPrice > finalPrice) {
        // Zeige Original-Preis (ohne Rabatt)
        comparePrice.textContent = this.formatMoney(totalPrice);
        comparePrice.removeAttribute('hidden');
        comparePrice.className = 'text-subdued line-through';
      } else {
        comparePrice.setAttribute('hidden', '');
      }
    }
  },
  
  formatMoney(cents) {
    const amount = cents / 100;
    return new Intl.NumberFormat('de-DE', {
      style: 'currency',
      currency: 'EUR'
    }).format(amount);
  }
};

// Initialisiere Bundle Products beim DOM Load
document.addEventListener('DOMContentLoaded', () => {
  BundleProducts.init();
  BundleCartGrouping.init();
  BundlePriceCalculator.init();
});

// Bundle Cart Grouping - Gruppiert Bundle-Items im Cart
const BundleCartGrouping = {
  init() {
    // Initiale Gruppierung
    this.groupBundleItems();
    
    // Bei Cart Updates erneut gruppieren
    document.documentElement.addEventListener('cart:refresh', () => {
      setTimeout(() => this.groupBundleItems(), 100);
    });
    
    // Beobachte Cart Drawer
    const observer = new MutationObserver(() => {
      this.groupBundleItems();
    });
    
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      observer.observe(cartDrawer, { childList: true, subtree: true });
    }
  },
  
  groupBundleItems() {
    const cartItems = document.querySelectorAll('cart-item, .cart-item');
    const bundleGroups = new Map();
    
    cartItems.forEach(item => {
      // Suche nach Bundle Properties in den Properties
      const propertiesElements = item.querySelectorAll('.product-option');
      let bundleId = null;
      let bundleTitle = null;
      let bundleComponent = null;
      
      propertiesElements.forEach(prop => {
        const text = prop.textContent;
        if (text.includes('_bundle_id:')) {
          bundleId = text.split(':')[1]?.trim();
          prop.style.display = 'none'; // Verstecke die Property
        }
        if (text.includes('_bundle_title:')) {
          bundleTitle = text.split(':')[1]?.trim();
          prop.style.display = 'none';
        }
        if (text.includes('_bundle_component:')) {
          bundleComponent = text.split(':')[1]?.trim();
          prop.style.display = 'none';
        }
      });
      
      if (bundleId) {
        // Setze data-Attribute für CSS
        item.setAttribute('data-bundle-id', bundleId);
        if (bundleTitle) item.setAttribute('data-bundle-title', bundleTitle);
        if (bundleComponent) item.setAttribute('data-bundle-component', bundleComponent);
        
        // Gruppiere Items
        if (!bundleGroups.has(bundleId)) {
          bundleGroups.set(bundleId, []);
        }
        bundleGroups.get(bundleId).push(item);
      }
    });
    
    // Sortiere Bundle-Items zusammen
    bundleGroups.forEach((items, bundleId) => {
      if (items.length > 1) {
        const firstItem = items[0];
        items.slice(1).forEach(item => {
          firstItem.parentNode.insertBefore(item, firstItem.nextSibling);
        });
      }
    });
  }
};
